import { isAddress } from "web3-validator";
import { AddressPair } from "../../models/AddressPair";
import { ExportImportTransaction } from "../../models/Transaction";

/**
 * Wallets copy P-Chain addresses with the chain alias prefix ("P-flare1…"),
 * but the indexer expects the bare bech32 address ("flare1…").
 */
export function normalizeSearchInput(value: string): string {
  const trimmed = value.trim();
  return trimmed.toLowerCase().startsWith("p-") ? trimmed.slice(2) : trimmed;
}

export interface SearchRoute {
  path: string;
  replace: boolean;
  /** C-Chain address of the resolved address pair, if any. */
  cChainAddress: string | null;
}

/**
 * Picks the page to open for a search term from the lookup results.
 */
export function resolveSearchRoute(
  term: string,
  addressPair: AddressPair | null,
  cChainTransaction: ExportImportTransaction | null,
): SearchRoute {
  const pair =
    addressPair && (addressPair.address || addressPair.p_address)
      ? addressPair
      : null;

  if (pair || isAddress(term, false)) {
    return {
      path: `address/${pair ? pair.p_address : term}`,
      replace: true,
      cChainAddress: pair ? pair.address : null,
    };
  }

  if (cChainTransaction && cChainTransaction.id !== null) {
    return {
      path: `tx/c-chain/${cChainTransaction.tx_id}`,
      replace: true,
      cChainAddress: null,
    };
  }

  // normal transaction
  return { path: `tx/${term}`, replace: false, cChainAddress: null };
}
